"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/ScheduledMessage.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);

var _mentions = require('shared/services/mentions');


var _ReplyQuoteBlock = require('./Message/ReplyQuoteBlock'); var _ReplyQuoteBlock2 = _interopRequireDefault(_ReplyQuoteBlock);



const ACTION_LABELS = {
  edit: 'Edit',
  changeTime: 'Change time',
  sendNow: 'Send now',
  cancel: 'Cancel',
  dismiss: 'Dismiss',
  retry: 'Retry',
  reschedule: 'Edit & reschedule',
}







const ActionButton = _react.memo.call(void 0, ({ action, message, onAction }) => {
  const onClick = _react.useCallback.call(void 0, () => onAction(action, message), [onAction, action, message])
  return (
    _react2.default.createElement('button', { type: "button", className: "scheduled-message--action", onClick: onClick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 31}}
      , ACTION_LABELS[action]
    )
  )
})
ActionButton.displayName = 'ScheduledMessageActionButton'










// The dashed Scheduled bubble at the end of the thread. The clock and the
// word carry its meaning; the dashed border is decoration. The group's label
// is what a screen reader announces, so the heading line is hidden from it.
// A failed one's heading says why it wasn't sent; its text stays selectable
// to copy. A reply shows the same quote, and mentions the same highlight, as
// a sent message.
const ScheduledMessageBubble = ({ item, onAction, files, onJumpToMessage }) => {
  const failed = !!item.FailureText
  const { ConversationKey, ReplyToMessageKey, Text, Mentions } = item.Scheduled
  return (
    _react2.default.createElement('div', {
      role: "group",
      'aria-label': item.AccessibilityLabel,
      className: _classBuilder2.default.call(void 0, 'scheduled-message', failed && 'scheduled-message--failed'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 57}}

      , _react2.default.createElement('div', { className: "scheduled-message--bubble", __self: this, __source: {fileName: _jsxFileName, lineNumber: 62}}
        , _react2.default.createElement('div', { className: "scheduled-message--heading", 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 63}}
          , _react2.default.createElement('i', { className: "material-icons scheduled-message--icon" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 64}}, failed ? 'error_outline' : 'schedule')
          , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 65}}
            , _react2.default.createElement('strong', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 66}}, item.Heading)
            , ` · ${item.TimeText}`
            , item.Byline ? ` · ${item.Byline}` : ''
          )
        )
        , ReplyToMessageKey && onJumpToMessage && (
          _react2.default.createElement(_ReplyQuoteBlock2.default, {
            conversationKey: ConversationKey,
            replyToMessageKey: ReplyToMessageKey,
            onJumpToMessage: onJumpToMessage, __self: this, __source: {fileName: _jsxFileName, lineNumber: 72}}
          )
        )
        , _react2.default.createElement('p', { className: "scheduled-message--text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 78}}
          , _mentions.splitTextWithMentions.call(void 0, Text, _nullishCoalesce(Mentions, () => ( undefined))).map(segment => segment.mention
            ? _react2.default.createElement('span', { key: segment.start, className: "message-mention", __self: this, __source: {fileName: _jsxFileName, lineNumber: 80}}, segment.text)
            : segment.text)
        )
        , files && files.length > 0 && (
          _react2.default.createElement('ul', { className: "scheduled-message--files", __self: this, __source: {fileName: _jsxFileName, lineNumber: 84}}
            , files.map(file => (
              _react2.default.createElement('li', { key: file.name, className: "scheduled-message--file", __self: this, __source: {fileName: _jsxFileName, lineNumber: 86}}
                , _react2.default.createElement('i', { className: "material-icons", 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 87}}, "attach_file")
                , file.name
              )
            ))
          )
        )
        , item.FailureDetail && _react2.default.createElement('p', { className: "scheduled-message--detail", __self: this, __source: {fileName: _jsxFileName, lineNumber: 93}}, item.FailureDetail)
      )
      , onAction && item.Actions.length > 0 && (
        _react2.default.createElement('div', { className: "scheduled-message--actions", __self: this, __source: {fileName: _jsxFileName, lineNumber: 96}}
          , item.Actions.map(action => (
            _react2.default.createElement(ActionButton, { key: action, action: action, message: item.Scheduled, onAction: onAction, __self: this, __source: {fileName: _jsxFileName, lineNumber: 98}} )
          ))
        )
      )
    )
  )
}

exports. default = _react.memo.call(void 0, ScheduledMessageBubble)
